import MenuRowSkeleton from "./MenuRowSkeleton";

export default MenuRowSkeleton;
